import type { enAirport } from './en.airport';

export const esAirport: typeof enAirport = {
  airport: {
    mapNames: { airport: 'Aeropuerto de Taoyuan' },
    zones: { ap_arrivals: 'Sala de llegadas', ap_terminal: 'Terminal 2', ap_gates: 'Puertas de embarque' },
    objects: {
      ap_mrt: 'Metro del aeropuerto (a Taipéi)',
      ap_mrtTaipei: 'Metro del aeropuerto (al aeropuerto)',
      ap_checkin: 'Mostrador de facturación',
      ap_info: 'Información',
      ap_security: 'Control de seguridad',
      ap_gate: 'Puerta C7 · Barcelona',
      ap_duty: 'Tienda libre de impuestos',
      ap_belt: 'Cinta de equipajes',
      wc_public: 'Baño público',
      rent_shop: 'Alquiler de vehículos',
      bank_counter: 'Banco Linterna',
      bank_atm: 'Cajero automático',
    },
    npc: {},
    items: {},
    texts: {
      mrtToAirport: 'La línea morada del metro va de la Estación Central de Taipéi al aeropuerto de Taoyuan en unos 40 minutos.',
      mrtGo: '🚇 Ir al aeropuerto',
      mrtBack: '🚇 Volver a Taipéi',
      mrtBackText: 'El metro del aeropuerto te lleva de vuelta a la Estación Central de Taipéi.',
      checkin: '¡Buenos días! ¿Adónde vuelas hoy? Ten el pasaporte a mano, por favor.',
      checkinAsk: '¿Cómo pides el billete en inglés?',
      ask: ['One ticket to Barcelona, please.', 'Barcelona give ticket me.', 'I want go Barcelona now.'],
      wrong: 'Mmm, inténtalo otra vez: piensa en «one ticket to… please».',
      ticket: (price: number) => `✈️ Barcelona — ${price} monedas (ida y vuelta)`,
      bought: 'Aquí tienes la tarjeta de embarque: puerta C7, asiento 23A, de ventanilla. Pasa el control de seguridad y sigue los carteles. ¡Buen viaje!',
      poor: (price: number) => `El vuelo de ida y vuelta a Barcelona cuesta ${price} monedas. ¡Ahorra en el banco y vuelve!`,
      haveTicket: 'Ya tienes tarjeta de embarque. ¡Pasa el control y ve a la puerta C7!',
      tooLate: (h: string) => `El último vuelo a Barcelona sale a las ${h} y hoy ya se ha ido. Prueba mañana por la mañana.`,
      flown: 'Hoy ya has volado. ¡Un gran viaje al día es suficiente!',
      securityText: 'Control de seguridad. Pon la mochila en la cinta. ¿Qué NO puedes llevar en el equipaje de mano?',
      securityQ: ['Una botella grande de agua', 'Un libro', 'Un bocadillo'],
      securityOk: '¡Correcto! Los líquidos de más de 100 ml se quedan fuera. Bébetela o tírala… y pasa.',
      securityWrong: 'Esa no. Piensa: ¿qué es líquido y más grande que un vaso?',
      securityDone: 'Ya has pasado el control. La puerta C7 está a la derecha.',
      securityNoTicket: '¡Tarjeta de embarque, por favor! Compra el billete en el mostrador primero.',
      gateText: 'Puerta C7. El vuelo BR 67 a Barcelona está embarcando. Unas 14 horas de vuelo… ¡llévate un libro!',
      board: '✈️ Subir al avión',
      needSecurity: 'Tienes que pasar el control de seguridad antes de embarcar.',
      needTicket: '¿Sin tarjeta de embarque? El mostrador está a la izquierda.',
      homeGate: '¡Bienvenido de vuelta a Taiwán! Cinta 4 y luego el metro a Taipéi.',
      info: 'El aeropuerto de Taoyuan abrió en 1979 y es el más grande de Taiwán. Dos terminales, aviones a más de 100 ciudades… y una tercera terminal en obras.',
      infoQ: '¿Cuál es el aeropuerto más grande de Taiwán?',
      infoA: ['Taoyuan', 'Songshan', 'Kaohsiung'],
      infoOk: '¡Sí! Por Taoyuan pasan casi todos los vuelos internacionales.',
      infoWrong: 'No exactamente… ¡es en el que estás ahora mismo!',
      duty: 'Libre de impuestos: pasteles de piña, té y mini Taipéi 101. ¿Un regalo para alguien de casa?',
      dutyBuy: '🍍 Pasteles de piña (40 monedas)',
      belt: 'Las maletas dan vueltas y vueltas. La tuya es la de la pegatina del conejito.',
      flyTo: ['Despegamos sobre las llanuras verdes de Taoyuan…', 'Nubes debajo, sol arriba… te duermes y te despiertas, te duermes y te despiertas…', '¡Montañas! Luego el Mediterráneo azul… y ahí está Barcelona.'],
      flyHome: ['El avión sube sobre el Mediterráneo…', 'Cena, una peli, un sueño largo…', 'Montañas verdes abajo: ¡Taiwán! Bienvenido a casa.'],
      announce: (place: string) => `“Ladies and gentlemen, welcome to ${place}.”`,
      arrive: (place: string) => `¡Bienvenido a ${place}!`,
    },
    hsr: {
      kaohsiung: 'Kaohsiung (alta velocidad)',
      tainan: 'Tainan (alta velocidad)',
      hintKaohsiung: 'la gran ciudad portuaria del sur',
      hintTainan: 'la ciudad más antigua, templos y tapas',
      toSouth: ['El tren de alta velocidad sale de la estación a 300 km/h…', 'Arrozales y estanques de peces pasan volando por la ventana…', 'Edificios altos al frente: ¡el sur de Taiwán!'],
    },
    wc: { text: 'Un baño público limpio. ¡Acuérdate de lavarte las manos!', use: '🚻 Ir al baño', wash: '🧼 Solo lavarme las manos' },
    rent: {
      text: '¡Alquila un vehículo para todo el día! Más rápido que andar… y el casco es gratis.',
      bike: '🚲 Bici',
      kick: '🛴 Patinete',
      ebike: '🛵 Moto eléctrica (con casco)',
      price: (n: number) => `${n} monedas`,
      rented: (what: string) => `Has alquilado ${what}. Devuélvelo en cualquier tienda de alquiler, o simplemente entra en algún sitio.`,
      names: { bike: 'una bici', kick: 'un patinete', ebike: 'una moto eléctrica' },
      ret: '↩️ Devolver el vehículo',
      returned: '¡Gracias! Vehículo devuelto.',
      poor: 'No tienes monedas suficientes para ese.',
      indoor: 'Dejas el vehículo en la puerta: ¡dentro no se circula!',
      helmet: '¡Casco puesto! En Taiwán todo el mundo lo lleva en moto.',
      rule: 'Ve despacio cerca de la gente y nunca por la acera con la moto.',
    },
    bank: {
      title: '🏦 Banco Linterna',
      hello: (balance: number, coins: number) => `¡Bienvenido al Banco Linterna! Tu cuenta tiene **${balance}🪙**. En el bolsillo: **${coins}🪙**.`,
      atm: (balance: number, coins: number) => `Cajero automático. Cuenta: **${balance}🪙** · bolsillo: **${coins}🪙**.`,
      deposit: (n: number) => `⬆️ Ingresar ${n}🪙`,
      depositAll: (n: number) => `⬆️ Ingresarlo todo (${n}🪙)`,
      withdraw: (n: number) => `⬇️ Sacar ${n}🪙`,
      withdrawAll: (n: number) => `⬇️ Sacarlo todo (${n}🪙)`,
      statement: '📄 Movimientos',
      goal: '🎯 Objetivo de ahorro',
      why: '❓ ¿Por qué ahorrar en el banco?',
      whyText: 'El dinero en el banco está seguro y cada mañana el banco te paga un **2 % de interés**: un pequeño gracias por dejarlo ahí. ¡Cuanto más ahorras, más crece!',
      done: (balance: number) => `Hecho. Tu cuenta tiene ahora **${balance}🪙**.`,
      interest: (n: number, balance: number) => `🏦 El banco te ha pagado ${n}🪙 de intereses. Saldo: ${balance}🪙.`,
      empty: 'Tu cuenta está vacía. ¡Ingresa unas monedas para empezar a ganar intereses!',
      stmtTitle: 'Últimos movimientos',
      stmtNone: 'Todavía no hay movimientos.',
      kinds: { in: 'Ingreso', out: 'Retirada', interest: 'Intereses', goal: 'Objetivo logrado' },
      goalText: (goal: number, balance: number) => (goal ? `Tu objetivo: **${goal}🪙**. Tienes ${balance}🪙; te faltan ${Math.max(0, goal - balance)}.` : 'Aún no tienes objetivo. Elige uno: ¡al conseguirlo ganas estrellas!'),
      goalSet: (n: number) => `🎯 Ahorrar ${n}🪙`,
      goalClear: 'Quitar el objetivo',
      goalReached: (n: number) => `🎉 ¡Objetivo conseguido: ${n}🪙 ahorradas! +5⭐`,
      reward: '¿Ahorras para un vuelo? Barcelona cuesta 300 monedas.',
      poor: 'No llevas tanto en el bolsillo.',
      poorBank: 'No hay tanto en la cuenta.',
      payCard: (price: number, pocket: number, missing: number, bank: number) => `Son ${price}🪙 y llevas ${pocket}🪙 en el bolsillo. ¿Pagas los ${missing}🪙 que faltan con la tarjeta del banco? (cuenta: ${bank}🪙)`,
      payCardBtn: (n: number) => `💳 Pagar ${n}🪙 con la cuenta`,
      cannotPay: (price: number, pocket: number, bank: number) => `Son ${price}🪙. Llevas ${pocket}🪙 en el bolsillo y ${bank}🪙 en el banco: te faltan ${price - pocket - bank}🪙.`,
      wallet: '👛 Monedero',
      potName: 'Banco',
    },
    mapUi: {
      here: '📍 Aquí',
      taiwan: '🗺️ Taiwán',
      goHere: '🧭 Guíame',
      guiding: (what: string) => `🧭 Te guío hasta: ${what}`,
      pinCleared: 'Has llegado.',
      kinds: { transport: 'Transporte', rental: 'Alquiler', toilet: 'Baños', bank: 'Banco', food: 'Comida', shop: 'Tiendas', sight: 'Lugares', hotel: 'Hotel', info: 'Información', door: 'Puertas' },
      door: (to: string) => `Puerta a ${to}`,
      how: {
        town: 'Casa. Todo empieza aquí: la estación está al este de la calle mayor.',
        taipei: 'Tren desde la estación (60 monedas). MRT a Ximending, Longshan, Plaza de la Libertad y Beitou.',
        hualien: 'Tren desde la estación (90 monedas). Bus turístico a Taroko y Qixingtan.',
        kaohsiung: 'Alta velocidad desde la estación (150 monedas).',
        tainan: 'Alta velocidad desde la estación (130 monedas).',
        airport: 'Metro del aeropuerto desde la Estación Central de Taipéi.',
        barcelona: 'Vuelo desde el aeropuerto de Taoyuan (300 monedas, ida y vuelta). Facturar, control, puerta C7.',
      },
      youAreHere: 'Estás aquí',
      abroad: 'Extranjero',
    },
  },
};
